module.exports = __webpack_public_path__ + "dashboard/img/wiersz.8a477adb28bd16fb52d51508039b9f53.svg";